import { Flex, Box, Text } from "rebass";
import { getLocalizedString } from "../../../utils";
import { AiOutlineClose } from "react-icons/ai";
import { GridColor } from "../gridColors/GridColors";
const ModalColor = ({ onClose, colors, type, onClickColors }) => {
  return (
    <Flex
      backgroundColor="#646464"
      height={`calc(100vh - 50px)`}
      width="100%"
      flexDirection={"column"}
      sx={{
        position: "fixed",
        left: "0",
        top: "50px",
        zIndex: "99999",
      }}
      pt="10px"
      pl="10px"
      pr="10px"
    >
      <Flex
        alignItems={"center"}
        justifyContent={"space-between"}
        width={1}
        height={"fit-content"}
      >
        <Text color={"white"}>
          <em>{getLocalizedString("COLORS AVAILABILITY")}</em>
        </Text>

        <Box onClick={onClose}>
          <AiOutlineClose fontSize={35} color="white" />
        </Box>
      </Flex>

      <Box pt={"20px"}>
        <GridColor
          colors={colors}
          type={type}
          onClick={onClickColors}
          onClose={onClose}
        />
      </Box>
    </Flex>
  );
};

ModalColor.defaultProps = {
  onClose: () => {},
  onClickColors: () => {},
};

export { ModalColor };
